import vendorSlice from './vendor-slice';

export const { setSearchText } = vendorSlice.actions;

export default vendorSlice;
